import React from 'react';
import { Table } from 'antd';
import { Row, Col } from 'react-bootstrap';
import { dateTableFormatter } from '../../dynamic/dateFormatter';
import { numberFormatter } from '../formatters/numberFormatter';

const ComponentViewSession = React.forwardRef(({ idRow, isUsingMainCurrency, columns }, ref) => (
  <div ref={ref} style={{ fontFamily: 'Arial, sans-serif', padding: '20px', border: '1px solid black', borderRadius: '10px', maxWidth: '800px', margin: '0 auto', backgroundColor: 'white' }}>
    <h1 style={{ textAlign: 'center', marginBottom: '30px', color: 'black', fontSize: '24px', fontWeight: 'bold' }}>
      Session Details
    </h1>

    <Row className="mb-3" style={{ borderBottom: '1px solid black', paddingBottom: '10px' }}>
      <Col md={4} style={{ fontWeight: 'bold', color: 'black' }}>Opened At:</Col>
      <Col md={8} style={{ color: 'black' }}>{dateTableFormatter(idRow?.openedAt)}</Col>
    </Row>

    <Row className="mb-3" style={{ borderBottom: '1px solid black', paddingBottom: '10px' }}>
      <Col md={4} style={{ fontWeight: 'bold', color: 'black' }}>Closed At:</Col>
      <Col md={8} style={{ color: 'black' }}>{dateTableFormatter(idRow?.closedAt)}</Col>
    </Row>

    <Row className="mb-4" style={{ borderBottom: '1px solid black', paddingBottom: '10px' }}>
      <Col md={4} style={{ fontWeight: 'bold', color: 'black' }}>Opening Balance:  {numberFormatter(isUsingMainCurrency ? idRow?.openingBalance : idRow?.secondaryOpeningBalance)}</Col>
    </Row>

    <h2 style={{ margin: '20px 0', color: 'black', fontSize: '20px', borderBottom: '2px solid black', paddingBottom: '5px', fontWeight: 'bold' }}>
      Journal Vouchers
    </h2>
    <Table
      columns={columns}
      dataSource={idRow?.journalVouchers}
      pagination={false}
      bordered
      style={{ marginBottom: '20px', color: 'black', border: '1px solid black' }}
    />

    <Row className="mb-3" style={{ alignItems: 'center' }}>
      <Col md={4} style={{ fontWeight: 'bold', color: 'black', display: 'flex', alignItems: 'center' }}>
        Balance:   {numberFormatter(isUsingMainCurrency ? idRow?.balance : idRow?.secondaryBalance)}
      </Col>
    </Row>

    <Row className="mb-3" style={{ alignItems: 'center' }}>
      <Col md={4} style={{ fontWeight: 'bold', color: 'black', display: 'flex', alignItems: 'center' }}>
        Variance:  {numberFormatter(isUsingMainCurrency ? idRow?.variance : idRow?.secondaryVariance)}
      </Col>
    </Row>
  </div>
));

export default ComponentViewSession;